<template>
    <div id="feedback_attempt" :class="{'five_minutes': fiveMinutes, 'fadeOut': transition}" v-show="showFeedback">
        <!-- <img v-if="attempt == 'game_over_loop'" :src="`/img/icons/feedback_${attempt}_${colors.theme}.gif`" alt="Feedback visual"> -->
        <img :src="`/img/icons/feedback_${attempt}_${colors.theme}.png`" :alt="`${attempt}`">
    </div>   
</template>

<script>
export default {
    name: 'FeedbackAttempt',
    props:['showFeedback', 'attempt', 'fiveMinutes', 'transition', 'colorTheme'],
    data: function(){
        return{
            colors:{}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        // console.log("attempt: ", this.attempt)
    }
}
</script>
<style lang="scss" scoped>
    #feedback_attempt{
        height: 100%;
        width: 100%;
        max-width: 900px;
        z-index: 99;
        background: rgba($color: #000, $alpha: .8);
        justify-content: center;
        align-items: center;
        display: flex;
        -webkit-transition: opacity .8s ease-in-out;
        -moz-transition: opacity .8s ease-in-out;
        -ms-transition: opacity .8s ease-in-out;
        -o-transition: opacity .8s ease-in-out;
        opacity: 1;
        position: absolute;
        top: 0;

        img{
            max-width: 100%;
            max-height: 35%;
        }
    }   
    #feedback_attempt.five_minutes{
        background: rgba($color: #fff, $alpha: .4);
        background: linear-gradient(50deg, rgba($color: #fff, $alpha: .4) 65%, rgba($color: #fff, $alpha: .4) 44%, rgba(255,245,129,1) 97%, rgba(255,245,129,1) 100%);
        margin-left: -15px;
        align-items: flex-start;
        
        img{
            max-width: 60%;
            max-height: 15%;
            top: 85px;
            right: -5px;
            position: absolute;
        }

    }
    #feedback_attempt.fadeOut{
        opacity: 0;
    }   
</style>
